module.exports = __webpack_public_path__ + "static/media/award.ba143587.png";